import { render, staticRenderFns } from "./LoginDialog.vue?vue&type=template&id=048e4fce&scoped=true"
import script from "./LoginDialog.vue?vue&type=script&lang=ts"
export * from "./LoginDialog.vue?vue&type=script&lang=ts"
import style0 from "./LoginDialog.vue?vue&type=style&index=0&id=048e4fce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048e4fce",
  null
  
)

export default component.exports